import { render, staticRenderFns } from "./TemplateSetup.vue?vue&type=template&id=45897a7e&scoped=true&"
import script from "./TemplateSetup.vue?vue&type=script&lang=ts&"
export * from "./TemplateSetup.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSetup.vue?vue&type=style&index=0&id=45897a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45897a7e",
  null
  
)

export default component.exports